import * as $ from 'jquery';
import store from 'store';

import 'devbridge-autocomplete';

const $autoCompleteItem = $('.autocomplete');
const $geoLocatorItem = $('.geolocate');

let working = false;
let session = false;

if($autoCompleteItem.length > 0) {
  $autoCompleteItem.autocomplete({
    minChars: 3,
    noCache: true,
    preventBadQueries: false,
    serviceUrl: `/app/find-emergency-vet/?action=search`,
    paramName: 's',
    onSearchStart: (function(params) {
      if(!session) {
        session = Math.random().toString(36).substr(2) + Date.now().toString(36);
      }
      params.session = session;

      return params;
    }),
    transformResult: (function(response) {
      response = typeof(response) === 'string' ? JSON.parse(response) : response;

      return {
        suggestions: $.map(response.body, function(place) {
          return {
            value: place.description,
            data: place
          };
        })
      };
    }),

    formatResult: (function(suggestion, value) {
      var place = suggestion.data;

      var mainText = place.structured_formatting.main_text || '',
          secondaryText = place.structured_formatting.secondary_text || '';

      mainText = mainText.replace(value, `<strong>${value}</strong>`);
      secondaryText = secondaryText.replace(value, `<strong>${value}</strong>`);

      var returnString = mainText + (secondaryText ? ` <small>${secondaryText}</small>` : '');

      return returnString;
    }),

    onSelect: function(object) {
      session = false;

      const $this = $(this);
      var data = object.data;

      var placeData = {
        place_id: data.place_id,
        address: data.description,
        place: data
      };

      $this.data('place', placeData);
      $this.trigger('maps_place_changed', placeData);

      return object.value;
    },
  });
}

const addGeoLocator = (function() {

  if(!'geolocation' in navigator) {
    return false;
  }

  $geoLocatorItem.removeClass('hidden').on('click', function(e) {
    e.preventDefault();

    const $this = $(this);
    $this.addClass('loading');
    $this.attr('aria-busy', 'true');

    navigator.geolocation.getCurrentPosition((position) => {

      const latLng = getLatLngFromGeolocation(position);

      $this.trigger('geo_place_changed', {
        address:'',
        latLng,
        place: {}
      });

      $this.removeClass('loading');
      $this.attr('aria-busy', 'false');

    }, (error) => { // An error occurred.

      alert('An error occurred getting your location.');
      console.error(`A geolocation error occurred: ${error.code}: ${error.message}`, error);

      $this.removeClass('loading');
      $this.attr('aria-busy', 'false');

    }, {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeout: 5000
    });
  });

});

if($geoLocatorItem.length > 0) {
  addGeoLocator();
}



const getLatLngFromLocation = (function(location) {
  return {
    lat: location.lat(),
    lng: location.lng()
  }
});


const getLatLngFromGeolocation = (function(position) {
  return {
    lat: position.coords.latitude,
    lng: position.coords.longitude,
  }
});
